import i18n from "@/locales";

export default [
  {
    // App下载
    path: "/app-down",
    name: "app-down",
    component: () => import("@/views/app-down/Index.vue"),
    meta: {
      showHeader: false,
      keepAlive: false,
      title: 'App下载'
    }
  },

];
